import { createProvideInject } from '@collector/shared-ui'

import { PocketIncidentsConfig } from '../configuration'

export const [providePocketIncidentsConfig, injectPocketIncidentsConfig] =
  createProvideInject<PocketIncidentsConfig>('pocketIncidentsConfig')
